<template>
  <PoppinsCheckbox
    v-model="form.termsAccepted"
    name="termsAccepted"
    checkboxId="terms-of-service"
    labelClass="mb-0"
    :formattedLabelText="`I agree to the <a target='_blank' href='${termsOfUseLink}' class='text-grey-clickable underline sign-up-form-link'>Terms of Use</a>. For details on collection and use of your information, see our <a target='_blank' href='${privacyPolicyLink}' class='text-grey-clickable underline sign-up-form-link'>Privacy Policy</a>.`"
    :status="formStatuses.termsAccepted"
    :helperText="helperText(formStatuses.termsAccepted)"
    :required="true"
    @blur="validate"
  />
</template>

<script lang="ts">
import helperStatus from '../../helpers/status';
import Checkbox from '../checkbox/Checkbox.vue';

export default {
  name: 'PoppinsTermsOfUse',
  components: {
    PoppinsCheckbox: Checkbox,
  },
  props: {
    termsOfUseLink: {
      type: String,
      required: true,
    },
    privacyPolicyLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        termsAccepted: false,
      },
      formStatuses: {
        termsAccepted: helperStatus.Neutral,
      },
    };
  },
  watch: {
    'form.termsAccepted': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onInput();
        this.formStatuses.termsAccepted = helperStatus.Neutral;
      }
    },
  },
  methods: {
    onInput() {
      this.$emit('input', 'termsAccepted', this.form.termsAccepted);
    },
    validate() {
      if (!this.form.termsAccepted) {
        this.formStatuses.termsAccepted = helperStatus.Error;
      }

      return this.form.termsAccepted;
    },
    helperText(status: helperStatus) {
      if (status === helperStatus.Error) {
        return 'You must agree to the Terms of Use';
      }
      return '';
    },
  },
};
</script>
